import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { AnchorResult, PhraseWord, ReferenceIssue, ReferencePhrase, RefMatch } from 'src/app/shared/models/common';
import { IndPhrase } from 'src/app/shared/models/cat.model';
import { getObjectPropValue } from '@shared/utils';
import { NgRedux } from '@shared/redux/redux-compatibility.service';
import { AppState } from '@shared/redux/store';
import { main } from '@popperjs/core';
import { RevRule } from '@shared/models/rev.model';

@Component({
    selector: 'cat-match-phrase-ref',
    templateUrl: './cat-match-phrase-ref.component.html',
    styleUrls: ['./cat-match-phrase-ref.component.scss'],
    standalone: false
})
export class CatMatchPhraseRefComponent implements OnInit, OnChanges {
  @Input() ref?: ReferencePhrase;
  @Input() catPhrase: IndPhrase;
  @Input() mainPhrase: IndPhrase | RevRule;
  @Input() disableConsistencyCheckResultsActions: boolean = false;
  @Input() referenceIssue?: ReferenceIssue;
  showOriginal: boolean = false;
  useCharBasedPhraseDiff = true;
  @Input() refMatches: RefMatch[] = [];
  @Input() showBorderIndicator: boolean = false;

  @Output()anchorPathChange: EventEmitter<{ isDirty: boolean, anchor: AnchorResult }> = new EventEmitter<{ isDirty: boolean, anchor: AnchorResult }>();

  catMatchReference: ReferencePhrase | undefined;

  constructor(private ngRedux: NgRedux<AppState>){}
  ngOnInit(): void {

    const uiConfig = this.ngRedux.getState().uiConfig;
    this.useCharBasedPhraseDiff = getObjectPropValue(uiConfig, 'cat_match_phrase_display_settings.use_char_based_phrase_diff') ?? false;

  }
  ngOnChanges(changes: SimpleChanges): void {

    this.catMatchReference = undefined;
    
      for (let ref of this.catPhrase.references) {
        for (let match of this.refMatches) {
          if (ref.refPhraseId === match.catRefPhraseId && this.ref?.refPhraseId == match.refPhraseId) {
            this.catMatchReference = ref;
          }
        }
      }
      if (!this.catMatchReference) {
        for (let ref of this.catPhrase.references) {
          if (ref.refPhraseId === this.referenceIssue?.catRefPhraseId) {
            this.catMatchReference = ref;
            break;
          }
        }
      }
    
  }

  toggleDisplayAnchors(): void {
    this.catMatchReference.showAnchors = !this.catMatchReference.showAnchors;
  }

  onAnchorPathChange(): void {
        
        
    this.anchorPathChange.emit();
      
      // emit for curRule 
      

  }
  getBorderClass(): string {
    if (!this.showBorderIndicator || !this.catMatchReference || this.catMatchReference.refType == 'FOOTNOTE') {
      return '';
    }

    return this.catMatchReference.isConsistencyGenerated ? 'border-indicator-anchor' : 'border-indicator-reference';

  }
}
